var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEFAULT_THEME, PARTNER_THEME } from './default-themes';
var isObject = function (value) {
    return typeof value === 'object' && !Array.isArray(value);
};
var hasThemeProps = function (value) {
    return Object.keys(DEFAULT_THEME).every(function (key) { return key in value; });
};
var isValidTheme = function (value) {
    return isObject(value) && hasThemeProps(value);
};
var themeSubscriptions = [];
export var selectedTheme = DEFAULT_THEME;
export var subscribeTheme = function (listener) {
    return themeSubscriptions.push(listener);
};
export var unsubscribeTheme = function (subToRemove) {
    themeSubscriptions = themeSubscriptions.filter(function (sub) { return sub !== subToRemove; });
};
var getTheme = function (theme) {
    if (isValidTheme(theme))
        return theme;
    else if (typeof theme === 'string') {
        if (theme === 'asurion')
            return DEFAULT_THEME;
        else if (theme === 'partner')
            return PARTNER_THEME;
    }
    console.warn('theme param is not valid, should be type of Theme or ThemeKey - provided: ', { theme: theme });
    return PARTNER_THEME;
};
export var updateTheme = function (theme, 
/**
@deprecated overrides is deprecated and will be deleted in v3, please remove overrides param.
*/
overrides) {
    selectedTheme = __assign(__assign({}, getTheme(theme)), overrides);
    themeSubscriptions.forEach(function (f) { return f(selectedTheme); });
};
